import React from "react";
import { Loader2 } from "lucide-react";
import { SignaturePreviewFrame } from "@/components/SignaturePreview";
import { TEMPLATES } from "@/constants/testIds";
import { useRenderedPair } from "@/hooks/useRenderedPair";

export function RenderedCompare({ left, right, userId, enabled }) {
  const rendered = useRenderedPair(left.html_content, right.html_content, userId, enabled);
  return (
    <div className="space-y-2">
      {rendered.loading && (
        <div className="flex items-center gap-1.5 text-[11px] text-slate-500" data-testid="compare-rendered-loading">
          <Loader2 className="w-3.5 h-3.5 animate-spin text-orange-600" strokeWidth={1.75} /> Renderizando con el usuario de referencia...
        </div>
      )}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <SignaturePreviewFrame html={rendered.left} mode="desktop" testId={TEMPLATES.compareRenderedLeft} />
        <SignaturePreviewFrame html={rendered.right} mode="desktop" testId={TEMPLATES.compareRenderedRight} />
      </div>
    </div>
  );
}
